import { gsap } from '../animations';

/**
 * Intro animata del block Hero (replica la timeline del mockup):
 * ken-burns sull'immagine, fade-in dell'overlay, pop-in header,
 * reveal scaglionato di sopratitolo / titolo / sottotitolo+CTA.
 */
export function initHero() {
	const hero = document.querySelector( '.hero' );
	if ( ! hero ) {
		return;
	}
	if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
		return;
	}

	const sel    = ( s ) => hero.querySelector( s );
	const imgs   = hero.querySelectorAll( '.hero-img img' );
	const header = document.getElementById( 'site-header' );

	// Ken-burns sull'immagine, disaccoppiato dalla timeline del testo: lo stato
	// iniziale (scale 1.08) è impostato subito per evitare il "pop", ma lo zoom parte
	// solo a immagine decodificata e con il layer GPU già promosso (will-change),
	// così i primi frame non scattano per la rasterizzazione del bitmap full-screen.
	if ( imgs.length ) {
		const season = document.body.dataset.season;
		const active = hero.querySelector( `.hero-img img[data-season="${ season }"]` ) || imgs[0];

		// Anima e promuove a layer GPU SOLO l'immagine visibile: quella stagionale
		// nascosta (opacity:0) non va animata, sarebbe lavoro doppio del compositor.
		gsap.set( active, { scale: 1.08, willChange: 'transform' } );

		const kenBurns = () => gsap.to( active, {
			scale: 1,
			duration: 2.6,
			ease: 'power1.out',
			onComplete: () => gsap.set( active, { willChange: 'auto' } ),
		} );

		if ( typeof active.decode === 'function' ) {
			active.decode().then( kenBurns ).catch( kenBurns );
		} else {
			kenBurns();
		}
	}

	const tl = gsap.timeline( { defaults: { ease: 'power2.out' } } );

	if ( sel( '.hero-overlay' ) ) {
		tl.fromTo( sel( '.hero-overlay' ), { opacity: 0 }, { opacity: 1, duration: 1.2, ease: 'power1.inOut' }, 0.7 );
	}
	if ( header ) {
		tl.fromTo( header, { y: -20, opacity: 0 }, { y: 0, opacity: 1, duration: 0.6 }, 1.1 );
	}
	if ( sel( '[data-hero="eyebrow"]' ) ) {
		tl.fromTo( sel( '[data-hero="eyebrow"]' ), { y: 24, opacity: 0 }, { y: 0, opacity: 1, duration: 0.7 }, 1.3 );
	}
	if ( sel( '[data-hero="title"]' ) ) {
		tl.fromTo( sel( '[data-hero="title"]' ), { y: 28, opacity: 0 }, { y: 0, opacity: 1, duration: 0.8, ease: 'power3.out' }, 1.5 );
	}
	if ( sel( '[data-hero="subrow"]' ) ) {
		tl.fromTo( sel( '[data-hero="subrow"]' ), { y: 20, opacity: 0 }, { y: 0, opacity: 1, duration: 0.7 }, 1.7 );
	}
}
